import { render, staticRenderFns } from "./CompInformationToTarifBigImage.vue?vue&type=template&id=5298fc26"
import script from "./CompInformationToTarifBigImage.vue?vue&type=script&lang=js"
export * from "./CompInformationToTarifBigImage.vue?vue&type=script&lang=js"
import style0 from "./CompInformationToTarifBigImage.vue?vue&type=style&index=0&id=5298fc26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports